import { render } from "./join.vue?vue&type=template&id=94ad4106&scoped=true"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"

import "./join.vue?vue&type=style&index=0&id=94ad4106&scoped=true&lang=css"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ad4106"]])

export default __exports__